export default {
  'vip.exchange.title': 'Cấu hình trao đổi giá trị tăng trưởng VIP',
  'vip.exchange.ruleTitle': 'Mô tả quy tắc VIP',
  'vip.exchange.currency': 'Loại tiền',
  'vip.exchange.amount': 'Số tiền',
  'vip.exchange.growthValue': 'Giá trị tăng trưởng VIP',
  'vip.exchange.enterAmount': 'Vui lòng nhập số tiền',
  'vip.exchange.enterGrowthValue': 'Vui lòng nhập giá trị tăng trưởng',
  'vip.exchange.enterValidNumber': 'Vui lòng nhập số hợp lệ (tối đa 2 chữ số thập phân)',
  'vip.exchange.enterPositiveInteger': 'Vui lòng nhập số nguyên dương',
  'vip.exchange.refresh': 'Làm mới',
  'vip.exchange.save': 'Lưu',
  'vip.exchange.saveSuccess': 'Lưu thành công',
  'vip.exchange.saveFailed': 'Lưu thất bại, vui lòng kiểm tra đầu vào',
  'vip.exchange.dataLoadFailed': 'Tải dữ liệu thất bại',
  'vip.exchange.ruleContent': 'Vui lòng nhập mô tả quy tắc VIP',
  'vip.exchange.ruleContentRequired': 'Vui lòng nhập mô tả quy tắc VIP',
  'vip.log.grow.title': 'Hồ sơ giá trị tăng trưởng VIP',
  'vip.log.level.title': 'Hồ sơ thay đổi VIP',
  'vip.log.memberAccount': 'Tài khoản thành viên',
  'vip.log.level': 'Cấp VIP',
  'vip.log.changeReason': 'Lý do thay đổi',
  'vip.log.beforeGrow': 'Giá trị tăng trưởng VIP trước khi thay đổi',
  'vip.log.grow': 'Thay đổi giá trị tăng trưởng VIP',
  'vip.log.afterGrow': 'Giá trị tăng trưởng VIP sau khi thay đổi',
  'vip.log.createTime': 'Thời gian tạo',
  'vip.log.changeTime': 'Thời gian thay đổi',
  'vip.log.changeType': 'Loại thay đổi',
  'vip.log.beforeLevel': 'Trước khi thay đổi',
  'vip.log.afterLevel': 'Sau khi thay đổi',
  'vip.log.operator': 'Người vận hành',
  'vip.log.upgrade': 'Nâng cấp',
  'vip.log.downgrade': 'Hạ cấp',
  'vip.log.enterMemberAccount': 'Vui lòng nhập tài khoản thành viên',
  'vip.log.selectChangeType': 'Vui lòng chọn loại thay đổi',
  'vip.exchange.pageSubtitle': 'Cấu hình tỷ lệ trao đổi giá trị tăng trưởng cho số tiền nạp và doanh thu hợp lệ theo loại tiền, với điều khiển công tắc độc lập',
  'vip.exchange.depositChannel': 'Kênh trao đổi nạp tiền',
  'vip.exchange.depositChannelDesc': 'Chuyển đổi thời gian thực khi nạp tiền',
  'vip.exchange.betflowChannel': 'Kênh trao đổi doanh thu',
  'vip.exchange.betflowChannelDesc': 'Kích hoạt trang + chuyển đổi bất đồng bộ',
  'vip.exchange.enabled': 'Đã bật',
  'vip.exchange.disabled': 'Đã tắt',
  'vip.exchange.depositAmount': 'Số tiền nạp',
  'vip.exchange.depositGrowthValue': 'Giá trị tăng trưởng VIP',
  'vip.exchange.betflowAmount': 'Số tiền doanh thu hợp lệ',
  'vip.exchange.betflowGrowthValue': 'Giá trị tăng trưởng VIP',
  'vip.exchange.description': 'Mô tả',
  'vip.exchange.enterBetflowAmount': 'Vui lòng nhập số tiền doanh thu hợp lệ',
  'vip.exchange.enterBetflowGrowthValue': 'Vui lòng nhập giá trị tăng trưởng doanh thu',
  'vip.exchange.descDeposit': 'Mỗi {{amount}} {{currency}} nạp tiền = {{grow}} giá trị tăng trưởng',
  'vip.exchange.descBetflow': 'Mỗi {{amount}} {{currency}} doanh thu hợp lệ = {{grow}} giá trị tăng trưởng',
  'vip.exchange.previewSaveData': 'Xem trước dữ liệu lưu',
  'vip.exchange.formValidationFailed': 'Xác thực biểu mẫu thất bại',
  'vip.setup.level': 'Cấp VIP',
  'vip.setup.condition.title': 'Cài đặt điều kiện VIP',
  'vip.setup.unifiedReward.title': 'Cấu hình phần thưởng VIP thống nhất',
  'vip.setup.reward.title': 'Cài đặt phần thưởng VIP',
  'vip.setup.point.title': 'Cài đặt điểm VIP',
  'vip.setup.withdrawLimit.title': 'Cài đặt hạn mức rút tiền VIP',
  'vip.setup.upgradeReward': 'Phần thưởng nâng cấp',
  'vip.setup.flowMultiple': 'Số lần doanh thu',
  'vip.setup.retentionReward': 'Phần thưởng duy trì',
  'vip.setup.weeklySalary': 'Lương hàng tuần',
  'vip.setup.weeklyRequiresDeposit': 'Yêu cầu tiền gửi',
  'vip.setup.weeklyRequiresBetflow': 'Yêu cầu doanh thu',
  'vip.setup.monthlySalary': 'Lương hàng tháng',
  'vip.setup.monthlyRequiresDeposit': 'Yêu cầu tiền gửi',
  'vip.setup.monthlyRequiresBetflow': 'Yêu cầu doanh thu',
  'vip.setup.birthdayReward': 'Phần thưởng sinh nhật',
  'vip.setup.claimValidityDays': 'Ngày hiệu lực nhận',
  'vip.setup.enterUpgradeReward': 'Vui lòng nhập phần thưởng nâng cấp',
  'vip.setup.enterFlowMultiple': 'Vui lòng nhập số lần doanh thu',
  'vip.setup.enterRetentionReward': 'Vui lòng nhập phần thưởng duy trì',
  'vip.setup.enterWeeklySalary': 'Vui lòng nhập lương hàng tuần',
  'vip.setup.enterWeeklyRequiresDeposit': 'Vui lòng nhập yêu cầu tiền gửi',
  'vip.setup.enterWeeklyRequiresBetflow': 'Vui lòng nhập yêu cầu doanh thu',
  'vip.setup.enterMonthlySalary': 'Vui lòng nhập lương hàng tháng',
  'vip.setup.enterMonthlyRequiresDeposit': 'Vui lòng nhập yêu cầu tiền gửi',
  'vip.setup.enterMonthlyRequiresBetflow': 'Vui lòng nhập yêu cầu doanh thu',
  'vip.setup.enterBirthdayReward': 'Vui lòng nhập phần thưởng sinh nhật',
  'vip.setup.enterClaimValidityDays': 'Vui lòng nhập ngày hiệu lực nhận',
  'vip.setup.upgradePoint': 'Điểm nâng cấp',
  'vip.setup.retentionPoint': 'Điểm duy trì',
  'vip.setup.appDayPoint': 'Điểm hàng ngày APP',
  'vip.setup.h5DayPoint': 'Điểm hàng ngày H5',
  'vip.setup.verifyMobile': 'Xác thực di động',
  'vip.setup.enterUpgradePoint': 'Vui lòng nhập điểm nâng cấp',
  'vip.setup.enterRetentionPoint': 'Vui lòng nhập điểm duy trì',
  'vip.setup.enterAppDayPoint': 'Vui lòng nhập điểm hàng ngày APP',
  'vip.setup.enterH5DayPoint': 'Vui lòng nhập điểm hàng ngày H5',
  'vip.setup.upgradeGrow': 'Giá trị tăng trưởng nâng cấp ≥',
  'vip.setup.retentionGrow': 'Giá trị tăng trưởng duy trì ≥',
  'vip.setup.retentionDays': 'Ngày hiệu lực duy trì',
  'vip.setup.unlimited': 'Vĩnh viễn',
  'vip.setup.enterUpgradeGrow': 'Vui lòng nhập giá trị tăng trưởng nâng cấp',
  'vip.setup.enterRetentionGrow': 'Vui lòng nhập giá trị tăng trưởng duy trì',
  'vip.setup.enterRetentionDays': 'Vui lòng nhập ngày hiệu lực duy trì',
  'vip.setup.upgradeGrowValidation': 'Giá trị tăng trưởng nâng cấp VIP{currentLevel} ({currentValue}) phải lớn hơn giá trị tăng trưởng nâng cấp VIP{prevLevel} ({prevValue})',
  'vip.setup.retentionGrowValidation': 'Giá trị tăng trưởng duy trì VIP{currentLevel} ({currentValue}) phải lớn hơn giá trị tăng trưởng duy trì VIP{prevLevel} ({prevValue})',
  'vip.log.memberAccountRequired': 'Tài khoản thành viên không được để trống',
  'vip.log.dataLoadFailed': 'Tải dữ liệu thất bại',
  'vip.withdrawLimit.dailyLimit': 'Hạn mức rút tiền hàng ngày',
  'vip.withdrawLimit.enterWithdrawLimit': 'Vui lòng nhập hạn mức rút tiền',
  'vip.withdrawLimit.enterValidAmount': 'Vui lòng nhập số tiền hợp lệ (thập phân hoặc -1 cho không giới hạn)',
  'vip.withdrawLimit.unlimited': 'Không giới hạn',
  'vip.withdrawLimit.unlimitedHint': '-1=Không giới hạn',
  'vip.withdrawLimit.enableVipWithdraw': 'Bật hạn mức VIP',
  'vip.setup.ticket.title': 'Cài đặt vé tham gia VIP',
  'vip.setup.ticket.upgradeQuantity': 'Số lượng vé',
  'vip.setup.ticket.enterTicketNumber': 'Vui lòng nhập số lượng vé',
  'vip.setup.ticket.enterValidTicketNumber': 'Vui lòng nhập số lượng vé hợp lệ (thập phân hoặc -1 cho không giới hạn)',
  'vip.setup.ticket.unlimitedHint': '-1=Không giới hạn',
  'vip.setup.ticket.upgradeTicket': 'Phần thưởng nâng cấp VIP',
  'vip.setup.ticket.selectUpgradeTicket': 'Vui lòng chọn phần thưởng nâng cấp',
  'vip.setup.pointConfig.title': 'Cấu hình điểm',
  'vip.setup.pointConfig.minPoint': 'Điểm tối thiểu',
  'vip.setup.pointConfig.maxPoint': 'Điểm tối đa',
  'vip.setup.pointConfig.probability': 'Xác suất',
  'vip.setup.pointConfig.add': 'Thêm',
  'vip.setup.pointConfig.delete': 'Xóa',
  'vip.setup.pointConfig.save': 'Xác nhận',
  'vip.setup.pointConfig.cancel': 'Hủy bỏ',
  'vip.setup.pointConfig.minPointRequired': 'Vui lòng nhập điểm tối thiểu',
  'vip.setup.pointConfig.maxPointRequired': 'Vui lòng nhập điểm tối đa',
  'vip.setup.pointConfig.probabilityRequired': 'Vui lòng nhập xác suất',
  'vip.setup.pointConfig.minPointInvalid': 'Điểm tối thiểu phải là số nguyên dương',
  'vip.setup.pointConfig.maxPointInvalid': 'Điểm tối đa phải là số nguyên dương',
  'vip.setup.pointConfig.maxLessThanMin': 'Điểm tối đa không được nhỏ hơn điểm tối thiểu',
  'vip.setup.pointConfig.probabilityInvalid': 'Xác suất phải là số từ 0-100',
  'vip.setup.pointConfig.totalProbabilityError': 'Tổng xác suất phải bằng 100%, hiện tại là {total}%',
  'vip.setup.pointConfig.totalProbabilityWarning': 'Tổng xác suất phải bằng 100%',
  'vip.setup.pointConfig.setting': 'Cài đặt',
  'vip.setup.pointConfig.totalProbability': 'Tổng Xác Suất',
  'vip.setup.pointConfig.action': 'Hành Động',
  'vip.setup.pointConfig.count': 'Số lượng',
  'vip.setup.pointConfig.title': 'Cấu hình điểm',
  'vip.setup.pointConfig.minPoint': 'Điểm tối thiểu',
  'vip.setup.pointConfig.maxPoint': 'Điểm tối đa',
  'vip.setup.pointConfig.probability': 'Xác suất',
  'vip.setup.pointConfig.add': 'Thêm',
  'vip.setup.pointConfig.delete': 'Xóa',
  'vip.setup.pointConfig.save': 'Xác nhận',
  'vip.setup.pointConfig.cancel': 'Hủy bỏ',
  'vip.setup.pointConfig.minPointRequired': 'Vui lòng nhập điểm tối thiểu',
  'vip.setup.pointConfig.maxPointRequired': 'Vui lòng nhập điểm tối đa',
  'vip.setup.pointConfig.probabilityRequired': 'Vui lòng nhập xác suất',
  'vip.setup.pointConfig.minPointInvalid': 'Điểm tối thiểu phải là số nguyên dương',
  'vip.setup.pointConfig.maxPointInvalid': 'Điểm tối đa phải là số nguyên dương',
  'vip.setup.pointConfig.maxLessThanMin': 'Điểm tối đa không được nhỏ hơn điểm tối thiểu',
  'vip.setup.pointConfig.probabilityInvalid': 'Xác suất phải là số từ 0-100',
  'vip.setup.pointConfig.totalProbabilityError': 'Tổng xác suất phải bằng 100%, hiện tại là {total}%',
  'vip.setup.pointConfig.totalProbabilityWarning': 'Tổng xác suất phải bằng 100%',
  'vip.setup.pointConfig.setting': 'Cài đặt',
  'vip.setup.pointConfig.totalProbability': 'Tổng Xác Suất',
  'vip.setup.pointConfig.action': 'Hành Động',

  
  // VIP Cấu hình phần thưởng thống nhất
  'vip.unified.scene.upgrade': 'Phần thưởng nâng cấp',
  'vip.unified.scene.retention': 'Phần thưởng giữ cấp',
  'vip.unified.scene.weekly': 'Lương tuần',
  'vip.unified.scene.monthly': 'Lương tháng',
  'vip.unified.scene.birthday': 'Phần thưởng sinh nhật',
  'vip.unified.scene.appDaily': 'APP hàng ngày',
  'vip.unified.scene.h5Daily': 'H5 hàng ngày',
  'vip.unified.basicReward': 'Phần thưởng cơ bản',
  'vip.unified.claimConditions': 'Điều kiện nhận thưởng',
  'vip.unified.rewardCurrency': 'Tiền tệ phần thưởng',
  'vip.unified.reward': 'Phần thưởng',
  'vip.unified.point': 'Điểm',
  'vip.unified.ticket': 'Vé tham gia',
  'vip.unified.flowMultiple': 'Bội số dòng tiền',
  'vip.unified.requiresDeposit': 'Yêu cầu gửi tiền',
  'vip.unified.requiresBetflow': 'Yêu cầu dòng tiền',
  'vip.unified.verifyMobile': 'Xác minh điện thoại',
  'vip.unified.pointConfig': 'Cấu hình điểm',
  'vip.unified.claimValidityDays': 'Ngày hiệu lực nhận thưởng',
  'vip.unified.enterReward': 'Vui lòng nhập phần thưởng',
  'vip.unified.enterPoint': 'Vui lòng nhập điểm',
  'vip.unified.enterFlowMultiple': 'Vui lòng nhập bội số dòng tiền',
  'vip.unified.enterRequiresDeposit': 'Vui lòng nhập yêu cầu gửi tiền',
  'vip.unified.enterRequiresBetflow': 'Vui lòng nhập yêu cầu dòng tiền',
  'vip.unified.enterClaimValidityDays': 'Vui lòng nhập ngày hiệu lực',
  'vip.unified.selectTicket': 'Vui lòng chọn vé tham gia',
  'vip.unified.enterQuantity': 'Vui lòng nhập số lượng',
  'vip.unified.quantity': 'Số lượng',

  // Điều chỉnh VIP thủ công
  'vip.adjust.title': 'Điều chỉnh VIP thủ công',
  'vip.adjust.singleTab': 'Điều chỉnh đơn lẻ',
  'vip.adjust.batchTab': 'Điều chỉnh hàng loạt',
  'vip.adjust.memberAccount': 'Tài khoản thành viên',
  'vip.adjust.enterMemberAccount': 'Nhập tài khoản và nhấn Enter để tìm kiếm',
  'vip.adjust.enterMemberAccountRequired': 'Vui lòng nhập tài khoản thành viên',
  'vip.adjust.query': 'Tìm kiếm',
  'vip.adjust.account': 'Tài khoản',
  'vip.adjust.currentVip': 'VIP hiện tại',
  'vip.adjust.growthValue': 'Giá trị tăng trưởng',
  'vip.adjust.toNextLevel': 'Đến cấp tiếp theo',
  'vip.adjust.maxLevel': 'Cấp tối đa',
  'vip.adjust.adjustType': 'Loại điều chỉnh',
  'vip.adjust.adjustGrow': 'Điều chỉnh giá trị tăng trưởng',
  'vip.adjust.adjustGrowDesc': 'Tăng hoặc giảm giá trị kinh nghiệm',
  'vip.adjust.adjustLevel': 'Điều chỉnh cấp VIP',
  'vip.adjust.adjustLevelDesc': 'Thay đổi trực tiếp cấp VIP',
  'vip.adjust.direction': 'Hướng điều chỉnh',
  'vip.adjust.increase': 'Tăng(+)',
  'vip.adjust.decrease': 'Giảm(-)',
  'vip.adjust.adjustValueLabel': 'Giá trị điều chỉnh',
  'vip.adjust.positiveInteger': 'Số nguyên dương',
  'vip.adjust.enterAdjustValue': 'Vui lòng nhập giá trị tăng trưởng cần điều chỉnh',
  'vip.adjust.exceedCurrentGrow': 'Giảm trừ không thể vượt quá giá trị tăng trưởng hiện tại ({{value}})',
  'vip.adjust.targetLevel': 'Cấp VIP mục tiêu',
  'vip.adjust.selectTargetLevel': 'Vui lòng chọn cấp mục tiêu',
  'vip.adjust.currentLevelTag': 'Cấp hiện tại',
  'vip.adjust.targetLevelSame': 'Cấp mục tiêu giống với cấp hiện tại',
  'vip.adjust.levelThresholdInfo': 'VIP{{level}} giá trị khởi đầu: {{threshold}}, giá trị tăng trưởng sẽ được đặt thành {{threshold}}',
  'vip.adjust.remark': 'Ghi chú',
  'vip.adjust.remarkOptional': 'Tùy chọn, tối đa 200 ký tự',
  'vip.adjust.remarkPlaceholder': 'VD: Bù hoạt động, bù lỗi hệ thống, giảm trừ rủi ro, v.v.',
  'vip.adjust.changePreview': 'Xem trước thay đổi',
  'vip.adjust.upgradeLabel': ' (Nâng cấp)',
  'vip.adjust.downgradeLabel': ' (Hạ cấp)',
  'vip.adjust.upgradeImpact': 'Phạm vi ảnh hưởng nâng cấp (thay đổi có hiệu lực ngay hoặc theo chu kỳ)',
  'vip.adjust.downgradeImpact': 'Phạm vi ảnh hưởng hạ cấp (thay đổi có hiệu lực ngay hoặc theo chu kỳ)',
  'vip.adjust.confirmTitle': 'Xác nhận thực hiện điều chỉnh?',
  'vip.adjust.confirmOk': 'Xác nhận',
  'vip.adjust.cancel': 'Hủy',
  'vip.adjust.confirmExec': 'Sắp thực hiện cho thành viên {{account}}:',
  'vip.adjust.confirmWarning': 'Thao tác này có hiệu lực ngay lập tức, không thể xóa bản ghi.',
  'vip.adjust.submitSuccess': 'Điều chỉnh thành công, đã cập nhật dữ liệu VIP cho {{account}}',
  'vip.adjust.submitFailed': 'Điều chỉnh thất bại, vui lòng thử lại',
  'vip.adjust.requestFailed': 'Yêu cầu thất bại, vui lòng thử lại',
  'vip.adjust.memberNotFound': 'Không tìm thấy thành viên, vui lòng xác nhận tài khoản',
  'vip.adjust.queryFailed': 'Truy vấn thất bại, vui lòng thử lại',
  'vip.adjust.lookupFirst': 'Vui lòng tìm kiếm tài khoản thành viên trước',
  'vip.adjust.enterValue': 'Vui lòng nhập giá trị điều chỉnh',
  'vip.adjust.confirmBtn': 'Xác nhận điều chỉnh',
  'vip.adjust.close': 'Đóng',
  'vip.adjust.manualAdjust': 'Điều chỉnh thủ công',
  'vip.adjust.system': 'Hệ thống',
  'vip.adjust.impact.upgradeReward': 'Thưởng nâng cấp: Kích hoạt VIP{{level}} (đã nhận không phát lại)',
  'vip.adjust.impact.withdrawLimit': 'Hạn mức rút tiền VIP: Thay đổi ngay thành VIP{{level}}',
  'vip.adjust.impact.retentionProtection': 'Chu kỳ giữ cấp: Tính lại từ hôm nay',
  'vip.adjust.impact.pointMall': 'Cửa hàng điểm/Vòng quay: Mở khóa tư cách VIP{{level}}',
  'vip.adjust.impact.customerService': 'Phân luồng CSKH: Lần chat tiếp theo theo VIP{{level}}',
  'vip.adjust.impact.notification': 'Tin nhắn nội bộ: Gửi thông báo nâng cấp',
  'vip.adjust.impact.noRecovery': 'Phần thưởng/điểm đã phát không thu hồi, theo tiêu chuẩn VIP{{level}}',
  'vip.adjust.impact.withdrawLimitDown': 'Hạn mức rút tiền VIP: Giảm ngay xuống VIP{{level}}',
  'vip.adjust.impact.loseQualification': 'Cửa hàng điểm/Vòng quay: Mất tư cách vượt VIP{{level}}',
  'vip.adjust.impact.noNotification': 'Tin nhắn nội bộ: Không gửi thông báo',
  'vip.adjust.uploadFile': 'Vui lòng tải lên tệp trước',
  'vip.adjust.batchTaskCreated': 'Đã tạo tác vụ hàng loạt, ID: {{taskId}}',
  'vip.adjust.uploadFailed': 'Xử lý tải lên thất bại',
  'vip.adjust.uploadError': 'Tải lên thất bại, vui lòng thử lại',
  'vip.adjust.templateDownloading': 'Đang tải mẫu...',
  'vip.adjust.templateDownloadFailed': 'Tải mẫu thất bại',
  'vip.adjust.downloadTemplate': 'Tải xuống mẫu nhập liệu',
  'vip.adjust.templateGuide': 'Hướng dẫn điền mẫu',
  'vip.adjust.colName': 'Tên cột',
  'vip.adjust.colRequired': 'Bắt buộc',
  'vip.adjust.colDesc': 'Mô tả',
  'vip.adjust.colExample': 'Ví dụ',
  'vip.adjust.colMemberAccountDesc': 'Giống với danh sách thành viên hệ thống',
  'vip.adjust.colAdjustTypeDesc': '1=Điều chỉnh giá trị tăng trưởng, 2=Điều chỉnh cấp VIP',
  'vip.adjust.colAdjustTypeExample': '1',
  'vip.adjust.colDirectionRequired': 'Bắt buộc khi điều chỉnh giá trị tăng trưởng',
  'vip.adjust.colDirectionDesc': '1=Tăng, 2=Giảm; để trống khi điều chỉnh cấp',
  'vip.adjust.colDirectionExample': '1',
  'vip.adjust.colValueDesc': 'Giá trị=số nguyên dương; Cấp=số cấp mục tiêu(0~30)',
  'vip.adjust.colRemarkRequired': 'Không',
  'vip.adjust.colRemarkDesc': '≤200 ký tự, dùng ghi chú lô nếu trống',
  'vip.adjust.colRemarkExample': 'Bù hoạt động',
  'vip.adjust.uploadDragText': 'Nhấp hoặc kéo để tải lên tệp CSV',
  'vip.adjust.uploadHint': 'Tối đa 5000 bản ghi, tệp ≤ 20MB',
  'vip.adjust.fileSizeLimit': 'Kích thước tệp không được vượt quá 20MB',
  'vip.adjust.batchRemark': 'Ghi chú lô',
  'vip.adjust.batchRemarkOptional': 'Tùy chọn, dùng chung cho lô này',
  'vip.adjust.batchRemarkPlaceholder': 'VD: Bù giá trị tăng trưởng hoạt động tháng 3',
  'vip.adjust.batchCreatedTitle': 'Đã tạo tác vụ điều chỉnh hàng loạt',
  'vip.adjust.batchCheckProgress': 'Tác vụ sẽ thực hiện bất đồng bộ, kiểm tra tiến độ trong tab "Tác vụ hàng loạt"',
  'vip.adjust.confirmBatch': 'Xác nhận điều chỉnh hàng loạt',
  'vip.adjust.yes': 'Có',

  // Tác vụ hàng loạt VIP
  'vip.batch.title': 'Tác vụ hàng loạt',
  'vip.batch.taskId': 'ID tác vụ',
  'vip.batch.fileName': 'Tên tệp',
  'vip.batch.totalCount': 'Tổng số',
  'vip.batch.success': 'Thành công',
  'vip.batch.fail': 'Thất bại',
  'vip.batch.status': 'Trạng thái',
  'vip.batch.batchRemark': 'Ghi chú lô',
  'vip.batch.operator': 'Người vận hành',
  'vip.batch.createTime': 'Thời gian tạo',
  'vip.batch.completeTime': 'Thời gian hoàn thành',
  'vip.batch.action': 'Hành động',
  'vip.batch.pending': 'Chờ xử lý',
  'vip.batch.processing': 'Đang xử lý',
  'vip.batch.completed': 'Đã hoàn thành',
  'vip.batch.failed': 'Thất bại',
  'vip.batch.unknown': 'Không xác định',
  'vip.batch.refresh': 'Làm mới',
  'vip.batch.failDetail': 'Chi tiết lỗi',
  'vip.batch.refreshList': 'Làm mới danh sách',
  'vip.batch.fetchFailed': 'Lấy danh sách tác vụ thất bại',
  'vip.batch.statusRefreshed': 'Đã làm mới trạng thái',
  'vip.batch.refreshFailed': 'Làm mới thất bại',
  'vip.batch.noFailDetail': 'Không có chi tiết lỗi để xuất',
  'vip.batch.exportSuccess': 'Xuất thành công',
  'vip.batch.exportFailed': 'Xuất thất bại',

  // Hạn mức rút tiền hàng ngày riêng cho thành viên (FBMPLAY-1704)
  'vip.memberLimit.buttonTitle': 'Hạn mức rút tiền',
  'vip.memberLimit.modalTitle': 'Thiết lập hạn mức rút tiền hàng ngày',
  'vip.memberLimit.currency': 'Tiền tệ',
  'vip.memberLimit.mode': 'Hạn mức rút hàng ngày · Cách áp dụng',
  'vip.memberLimit.modeVip': 'Theo hạn mức cấp VIP (mặc định)',
  'vip.memberLimit.modeMember': 'Theo hạn mức riêng của thành viên',
  'vip.memberLimit.amount': 'Hạn mức riêng hàng ngày (/ ngày)',
  'vip.memberLimit.amountHint': 'Có thể cao hơn hoặc thấp hơn mặc định VIP; -1 = không giới hạn; không cho phép 0',
  'vip.memberLimit.diff': '{sign}{diff} so với mặc định VIP{level}',
  'vip.memberLimit.diffSame': 'Bằng mặc định VIP{level}',
  'vip.memberLimit.diffVipUnlimited': 'Mặc định VIP{level} là không giới hạn',
  'vip.memberLimit.amountInvalid': 'Nhập -1 hoặc số tiền lớn hơn 0',
  'vip.memberLimit.enterAmount': 'Nhập hạn mức riêng hàng ngày',
  'vip.memberLimit.unlimited': 'Không giới hạn',
  'vip.memberLimit.unlimitedCell': 'Không giới hạn (-1)',
  'vip.memberLimit.perDay': 'ngày',
  'vip.memberLimit.remark': 'Ghi chú',
  'vip.memberLimit.enterRemark': 'Nêu lý do điều chỉnh lần này',
  'vip.memberLimit.effectHint': 'Có hiệu lực ngay; số đã rút hôm nay không đổi, hạn mức còn lại được tính lại',
  'vip.memberLimit.saveSuccess': 'Lưu thành công',
  'vip.memberLimit.saveFailed': 'Lưu thất bại',
  'vip.memberLimit.memberAccount': 'Tài khoản thành viên',
  'vip.memberLimit.enterMemberAccount': 'Nhập tài khoản thành viên',
  'vip.memberLimit.statusActive': 'Đang hiệu lực',
  'vip.memberLimit.statusDisabled': 'Đã tắt',
  'vip.memberLimit.operator': 'Người thao tác',
  'vip.memberLimit.enterOperator': 'Nhập người thao tác',
  'vip.memberLimit.operateTime': 'Thời gian thao tác',
  'vip.memberLimit.edit': 'Sửa',
};
